import { customerBaseApi } from "@/react/services/api";
import { HttpMethods } from "@/react/http";

const NOMADIC = Object.freeze("NOMADIC");
const BASE_URL = Object.freeze("nomadic/");

const nomadicApi = customerBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getNomadicStatus: builder.query({
      query: () => ({
        url: `${BASE_URL}status`,
        method: HttpMethods.GET,
      }),
      providesTags: [NOMADIC],
    }),
    setNomadic: builder.mutation({
      query: ({ provider }) => ({
        url: `${BASE_URL}setNomadic`,
        method: HttpMethods.POST,
        body: { provider },
      }),
      invalidatesTags: [NOMADIC],
    }),
    setStatic: builder.mutation({
      query: () => ({
        url: `${BASE_URL}setStatic`,
        method: HttpMethods.POST,
      }),
      invalidatesTags: [NOMADIC],
    }),
  }),
});

export const {
  useLazyGetNomadicStatusQuery,
  useSetNomadicMutation,
  useSetStaticMutation,
} = nomadicApi;
